import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import ScrollTop from "@/components/feature/ScrollTop";
import ContactForm from "@/components/feature/ContactForm";
import { useSeo } from "@/hooks/useSeo";
import { categories } from "@/mocks/videos";

const values = [
  { icon: "ri-focus-3-line", title: "内容定位", text: "专注于娱乐八卦、圈内速递、明星动态、综艺片段、影视花絮与红人视频，做娱乐圈信息的一站式聚集地。" },
  { icon: "ri-time-line", title: "更新理念", text: "坚持高频更新与快速跟进，让用户在第一时间掌握圈内最新动态，不错过任何一个热点。" },
  { icon: "ri-shield-check-line", title: "内容原则", text: "尊重事实、尊重原创、理性吃瓜。坚持信息可溯源，对存在争议的内容保持客观与克制。" },
];

const principles = [
  { num: "01", title: "真实为先", text: "所有热点信息力求有据可查，不捕风捉影、不恶意造谣，传播前先核实。" },
  { num: "02", title: "尊重原创", text: "重视内容版权与创作者劳动，转载与引用严格标注来源，保护每一位创作者的成果。" },
  { num: "03", title: "理性吃瓜", text: "倡导轻松快乐的围观氛围，拒绝恶意攻击与网络暴力，让吃瓜也能文明有温度。" },
];

const testimonials = [
  { name: "阿梨", role: "吃瓜老粉", text: "用了大半年，内容一直保持高质量和高频率，已经成为我每天的快乐源泉。" },
  { name: "陈默", role: "媒体从业者", text: "信息的时效性和覆盖面都很出色，很多热点在这里都能第一时间看到，专业度值得肯定。" },
  { name: "小鹿", role: "影视迷", text: "影视花絮板块做得特别用心，能真切感受到幕后工作者的不易，看完更有温度了。" },
];

export default function About() {
  useSeo({
    title: "关于我们 - 吃瓜视频网",
    description: "了解吃瓜视频网的品牌介绍、内容定位与发展理念。我们是聚焦娱乐八卦、圈内速递、明星动态、综艺片段、影视花絮与红人视频的资讯平台，理性吃瓜，快乐追剧。",
    keywords: "吃瓜视频网,关于我们,品牌介绍,内容定位,娱乐圈资讯平台",
  });

  return (
    <div className="min-h-screen">
      <Header />

      {/* hero */}
      <section className="bg-primary-600 text-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 text-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/15 text-background-50 text-xs font-bold">
            <i className="ri-flag-line"></i>关于我们
          </span>
          <h1 className="mt-4 font-heading text-3xl md:text-4xl">关于吃瓜视频网</h1>
          <p className="mt-3 text-sm md:text-base text-background-50/85 max-w-2xl mx-auto">
            专注娱乐圈资讯的一站式平台，收录娱乐八卦、圈内速递、明星动态、综艺片段、影视花絮与红人视频，让每一位吃瓜用户都能在这里找到想看的内容。
          </p>
        </div>
      </section>

      {/* brand intro */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 mt-10 md:mt-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">我们是谁</h2>
            <p className="mt-4 text-sm leading-7 text-foreground-700">
              吃瓜视频网诞生于对娱乐圈内容的持续热爱。在这个信息爆炸的时代，我们希望通过持续的筛选、整理与更新，把真正有温度、有价值的圈内动态带到每一个关注娱乐的用户面前。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              从娱乐八卦到圈内速递，从明星动态到综艺片段，从影视花絮到红人视频，我们力求做到“全收录、快更新、好阅读”，让每个人都能轻松地吃好每一口瓜。
            </p>
          </div>
          <img
            src="https://readdy.ai/api/search-image?query=modern%20creative%20media%20team%20working%20in%20a%20warm%20sunlit%20studio%20editing%20videos%20on%20screens%2C%20cinematic%20editorial%20photography%2C%20cozy%20golden%20light%2C%20collaborative%20atmosphere&width=900&height=600&seq=about-team-01&orientation=landscape"
            alt="吃瓜视频网内容团队"
            className="w-full h-64 md:h-80 object-cover rounded-lg"
            loading="lazy"
          />
        </div>
      </section>

      {/* values */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 mt-10 md:mt-14">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6 flex items-center gap-2">
          <span className="w-1.5 h-6 rounded bg-primary-500"></span>我们的定位与理念
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {values.map((v) => (
            <div key={v.title} className="bg-background-100 border border-background-200 rounded-lg p-6">
              <span className="w-12 h-12 rounded-lg bg-primary-500/10 text-primary-600 flex items-center justify-center text-2xl">
                <i className={v.icon}></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{v.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{v.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* principles */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 mt-10 md:mt-14">
        <div className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">内容原则</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {principles.map((p) => (
              <div key={p.num} className="flex gap-4">
                <span className="font-heading text-3xl text-primary-500 leading-none shrink-0">{p.num}</span>
                <div>
                  <h3 className="text-base font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{p.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* testimonials */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 mt-10 md:mt-14">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6 flex items-center gap-2">
          <span className="w-1.5 h-6 rounded bg-primary-500"></span>用户口碑
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <figure key={t.name} className="bg-background-100 border border-background-200 rounded-lg p-6">
              <div className="flex items-center gap-1 text-accent-500 text-sm">
                <i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i>
              </div>
              <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed">“{t.text}”</blockquote>
              <figcaption className="mt-4 text-xs text-foreground-500 flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-secondary-500/15 text-secondary-700 flex items-center justify-center"><i className="ri-user-line"></i></span>
                <span className="font-bold text-foreground-800">{t.name}</span>
                <span>· {t.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* categories quick link */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 mt-10 md:mt-14">
        <div className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8 text-center">
          <h2 className="font-heading text-2xl text-foreground-950">想开始吃瓜？从热门栏目逛起</h2>
          <div className="mt-5 flex flex-wrap justify-center gap-3">
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50 border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
              >
                <i className={c.icon}></i>{c.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* contact */}
      <section id="contact" className="mx-auto max-w-7xl px-4 md:px-6 mt-10 md:mt-14 scroll-mt-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start bg-background-100 border border-background-200 rounded-lg p-5 md:p-8">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/15 text-accent-700 text-xs font-bold">
              <i className="ri-chat-3-line"></i>联系我们
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-3xl text-foreground-950">欢迎留言、投稿与合作</h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              无论是对内容的建议、圈内线索的投稿，还是商务合作洽谈，欢迎通过表单或邮箱与我们联系。每一份真诚的声音，我们都会认真倾听。
            </p>
            <div className="mt-6 space-y-3 text-sm text-foreground-700">
              <p className="flex items-center gap-2"><i className="ri-mail-line text-primary-600"></i>contact@chigua-video.example.com</p>
              <p className="flex items-center gap-2"><i className="ri-time-line text-primary-600"></i>工作日 09:00 - 21:00 在线回复</p>
            </div>
          </div>
          <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
            <ContactForm />
          </div>
        </div>
      </section>

      <Footer />
      <ScrollTop />
    </div>
  );
}